import { render, staticRenderFns } from "./ListSerial.vue?vue&type=template&id=6c9c5728&"
import script from "./ListSerial.vue?vue&type=script&lang=js&"
export * from "./ListSerial.vue?vue&type=script&lang=js&"
import style0 from "./ListSerial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListNewsItem: require('/app/components/list/ListNewsItem.vue').default})
